var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 52416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path994",
    d: "M15.1107 14.339C14.3942 14.339 13.7204 14.0601 13.2138 13.5537L10.4748 10.8148C10.2826 10.6219 9.94739 10.6226 9.75517 10.8148L7.00623 13.5637C6.49958 14.07 5.82578 14.349 5.1093 14.349H4.56958L8.03844 17.8179C9.12183 18.9012 10.8783 18.9012 11.9617 17.8179L15.4406 14.339H15.1107Z",
    fill: "#787E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path998",
    d: "M5.10922 4.65089C5.8257 4.65089 6.49949 4.92994 7.00606 5.43633L9.755 8.1857C9.95297 8.38368 10.2763 8.38453 10.4747 8.18545L13.2136 5.4463C13.7203 4.9399 14.3941 4.66093 15.1106 4.66093H15.4405L11.9616 1.18212C10.8782 0.0987206 9.12175 0.0987206 8.03835 1.18212L4.56958 4.65089H5.10922Z",
    fill: "#787E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    d: "M18.318 7.53831L16.2157 5.43602C16.1694 5.45458 16.1193 5.46617 16.0664 5.46617H15.1106C14.6164 5.46617 14.1327 5.66655 13.7836 6.01594L11.0446 8.75492C10.7884 9.01121 10.4516 9.13953 10.1151 9.13953C9.77835 9.13953 9.44184 9.01121 9.18555 8.75518L6.43635 6.00598C6.08713 5.65658 5.60349 5.45621 5.10929 5.45621H3.93399C3.88392 5.45621 3.83703 5.44436 3.79279 5.42769L1.68218 7.53831C0.59878 8.62162 0.59878 10.3781 1.68218 11.4616L3.79271 13.5721C3.83694 13.5555 3.88392 13.5436 3.93399 13.5436H5.10929C5.60349 13.5436 6.08713 13.3432 6.43635 12.9939L9.18529 10.2449C9.68215 9.74848 10.5483 9.74822 11.0446 10.2452L13.7836 12.9838C14.1327 13.3333 14.6164 13.5337 15.1106 13.5337H16.0664C16.1194 13.5337 16.1694 13.5452 16.2158 13.5637L18.318 11.4616C19.4014 10.3781 19.4014 8.62162 18.318 7.53831Z",
    fill: "#787E7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.ef1435ba1e8023dada145e07beaa6696.svg";
export { ForwardRef as ReactComponent };